import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import AddIcon from '@mui/icons-material/Add';
import { ManufacturerDetails } from '../../INV/masters/ProductManagement/ManufacturerDetails';
import { ProductCategory } from '../../INV/masters/ProductManagement/ProductCategoryDetails';
import { Group } from '../../INV/masters/ProductManagement/Group';
import { SubGroup } from '../../INV/masters/ProductManagement/SubGroup';
import { MarketedBy } from '../../INV/masters/ProductManagement/MarketedBy';
import { ProductStorage } from '../../INV/masters/ProductManagement/ProductStorage';
import { RouteDetails } from '../../INV/masters/ProductManagement/RouteDetails';
import { PurchaseUom } from '../../INV/masters/ProductManagement/PurchaseUom';
import { PHARMACY_PRODUCT_TYPE } from '../../../../../constants';
import { TaxCategoryMaster } from '../../INV/masters/ProductManagement/TaxCategoryMaster';
import { PHARMACY_DRUG_SCHEDULE } from '../../../../../constants';

const PATIENT_TABLE_HEADER = [
  { header: 'UHID', accessor: 'uhid' },
  { header: 'OP No', accessor: 'op_no' },
  { header: 'Created At', accessor: 'createdAt' },
  { header: 'Patient Name', accessor: (row) => `${row.name_suffix} ${row.first_name} ${row.last_name}` },
  { header: 'Mobile No', accessor: 'address.mobile' },
  { header: 'Doctor', accessor: 'consultant.name' },
  { header: 'Address', accessor: 'address.address' }
];

const TABLE_HEADER = [
  {
    header: 'Product Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.name}`}
        </span>
      );
    }
  },
  {
    header: 'Product Code',
    accessor: (row) => row?.code_alias
  },
  {
    header: 'Category Name',
    accessor: (row) => row?.category?.category_name
  },
  {
    header: 'Product Group Name',
    accessor: (row) => row?.group?.group_name
  },
  {
    header: 'Purchase Unit',
    accessor: (row) => row?.purchasing_unit?.unit_name
  },
  {
    header: 'Manufacturer Name',
    accessor: (row) => row?.manuf?.manufacturer_name
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  },
  {
    header: 'CreatedAt',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  }
];

const initialOPDBillingDataObj = {
  data: [],
  loading: false
};

export const ProductMasters = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [opdBillingDataObj, setOpdBillingDataObj] = useState(initialOPDBillingDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [addManufacturerDialogOpen, setAddManufacturerDialogOpen] = useState(false);
  const [addGroupDialogueOpen, setAddGroupDialogueOpen] = useState(false);
  const [addCategoryDialogOpen, setAddCategoryDialogOpen] = useState(false);
  const [addSubGroupDialogue, setAddSubGroupDialogue] = useState(false);
  const [addMarketedByDialogue, setAddMarketedByDialogue] = useState(false);
  const [addCifDialogue, setAddCifDialogue] = useState(false);
  const [addProductStorageDialogue, setAddProductStorageDialogue] = useState(false);
  const [addRouteDetailsDialogue, setAddRouteDetailsDialogue] = useState(false);
  const [purUomDialogue, setPurUomDialogue] = useState(false);
  const [genericDialogue, setGenericDialogue] = useState(false);
  const [taxCategoryDialogue, setTaxCategoryDialogue] = useState(false);
  const [patientVitals, setPatientVitals] = useState([]);
  const [input, setInput] = useState('');
  const [originalData, setOriginalData] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [manufacturer, setManufacturer] = useState([]);
  const [category, setCategory] = useState([]);
  const [group, setGroup] = useState([]);
  const [subGroup, setSubGroup] = useState([]);
  const [marketed, setMarketed] = useState([]);
  const [therapeutic, setTherapeutic] = useState([]);
  const [storage, setStorage] = useState([]);
  const [route, setRoute] = useState([]);
  const [purcahseUom, setPurchaseUom] = useState([]);
  const [generic, setGeneric] = useState([]);
  const [taxCategory, setTaxCategory] = useState([]);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        name: Yup.string().required(' '),
        packing: Yup.string().required(' '),
        conversion: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      purchase_rate: 0,
      cost_price: 0,
      mrp: 0,
      sales_price_a: 0,
      sales_price_b: 0,
      sales_price_c: 0,
      auto_markup: 0,
      min_gp: 0,
      selling_unit: 0,
      sales_disc: 0,
      tax_percentage: 0,
      product_type: 'general product'
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  const getManufacturerDropdown = useCallback(async () => {
    const data = await dropdownFetch('manufacturer');
    setManufacturer(data);
  }, []);

  const getCategoryDropdown = useCallback(async () => {
    const data = await dropdownFetch('product-category');
    setCategory(data);
  }, []);

  const getGroupDropdown = useCallback(async () => {
    const data = await dropdownFetch('pharmacy-group');
    setGroup(data);
  }, []);

  const getSubGroupDropdown = useCallback(async () => {
    const data = await dropdownFetch('pharmacy-subgroup');
    setSubGroup(data);
  }, []);

  const getMarketedDropdown = useCallback(async () => {
    const data = await dropdownFetch('pharmacy-marketed');
    setMarketed(data);
  }, []);

  const getTherapeuticDropdown = useCallback(async () => {
    const data = await dropdownFetch('pharmacy-therapeutic');
    setTherapeutic(data);
  }, []);

  const getStorageDropdown = useCallback(async () => {
    const data = await dropdownFetch('pharmacy-storage');
    setStorage(data);
  }, []);

  const getRoute = useCallback(async () => {
    const data = await dropdownFetch('pharmacy-route');
    setRoute(data);
  }, []);

  const getPurchaseUom = useCallback(async () => {
    const data = await dropdownFetch('purchase-uom');
    setPurchaseUom(data);
  }, []);

  const getGenericDropdown = useCallback(async () => {
    const data = await dropdownFetch('generic-master');
    setGeneric(data);
  }, []);

  const getTaxCategoryDropdown = useCallback(async () => {
    const data = await dropdownFetch('tax-category-master');
    setTaxCategory(data);
  }, []);

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, '', ['_id', 'status', '__v']);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  useEffect(
    () => {
      getManufacturerDropdown();
      getCategoryDropdown();
      getGroupDropdown();
      getSubGroupDropdown();
      getMarketedDropdown();
      getTherapeuticDropdown();
      getStorageDropdown();
      getRoute();
      getPurchaseUom();
      getGenericDropdown();
      getTaxCategoryDropdown();
    },
    getManufacturerDropdown,
    getCategoryDropdown,
    getGroupDropdown,
    getSubGroupDropdown,
    getMarketedDropdown,
    getTherapeuticDropdown,
    getStorageDropdown,
    getRoute,
    getPurchaseUom,
    getGenericDropdown,
    getTaxCategoryDropdown
  );

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/store-product-master-update' : '/store-product-master-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: { ...formValues }
    });
    console.log('HELLO FORMVALUES', formValues);
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'}Product Master`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Product Master`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/store-product-master-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled Product', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel Product', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/store-product-master-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Product', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Product', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setOpdBillingDataObj({ loading: true });
    const response = await request('/store-product-master-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setOpdBillingDataObj({ loading: false, data: filteredData });
      setOriginalData(filteredData);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setOpdBillingDataObj({ loading: false });
    }
  };

  const handleActiveTab = (newTabIndex) => {
    setActiveTab(newTabIndex);
  };

  useEffect(() => {
    if (opdBillingDataObj.data && opdBillingDataObj.data.length > 0) {
      setOriginalData(opdBillingDataObj.data);
      setIsFiltered(false);
    }
  }, [opdBillingDataObj.data]);

  useEffect(() => {
    handleUhidSearch();
  }, [input]);

  const handleUhidSearch = () => {
    const lowercasedInput = input.toLowerCase();
    const filtered = opdBillingDataObj.data.filter((item) =>
      item?.main?.name?.toString().toLowerCase().includes(lowercasedInput)
    );
    setOriginalData(filtered);
  };
  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const fieldOneRef = useRef(null);
  const fieldTwoRef = useRef(null);
  const fieldThreeRef = useRef(null);
  const fieldFourRef = useRef(null);
  const handleKeyPress = (e, nextFieldRef) => {
    if (e.key === 'Tab' && nextFieldRef) {
      e.preventDefault();
      nextFieldRef.current.focus();
    }
  };
  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                Product Master
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  {activeTab === 0 && (
                    <>
                      {/* <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}> */}
                      <Stack sx={{ mb: 0.3, marginTop: '2%' }} direction="row" spacing={2}>
                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                          <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Name</Typography>
                          <TextField
                            sx={{
                              flex: 0.8,
                              border: currentAction ? '0.5px solid red' : ''
                            }}
                            name="name"
                            placeholder="Enter Product Name"
                            disabled={!['new', 'edit'].includes(currentAction)}
                            inputRef={fieldOneRef}
                            onKeyDown={(e) => handleKeyPress(e, fieldTwoRef)}
                          />
                        </Stack>
                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                          <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Code/Alias</Typography>
                          <TextField
                            disabled={!['new', 'edit'].includes(currentAction)}
                            sx={{ flex: 0.8 }}
                            name="code_alias"
                            placeholder="Enter Product/Alias"
                          />
                        </Stack>
                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                          <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Manuf.</Typography>
                          <SelectTag
                            disabled={!['new', 'edit'].includes(currentAction)}
                            formControlSX={{
                              flex: 0.8,
                              border: currentAction ? '0.5px solid red' : ''
                            }}
                            name="manuf"
                            placeholder="Manuf."
                            menus={manufacturer.map((data) => ({ ...data, name: data.manufacturer_name }))}
                          />
                          <Button
                            sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                            variant="contained"
                            onClick={() => setAddManufacturerDialogOpen(true)}
                          >
                            <AddIcon />
                          </Button>
                        </Stack>
                      </Stack>
                      <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                          <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Category</Typography>
                          <SelectTag
                            disabled={!['new', 'edit'].includes(currentAction)}
                            formControlSX={{
                              flex: 0.8,
                              border: currentAction ? '0.5px solid red' : ''
                            }}
                            name="category"
                            placeholder="Category"
                            menus={category.map((data) => ({
                              ...data,
                              name: data.category_name
                            }))}
                          />
                          <Button
                            sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                            variant="contained"
                            onClick={() => setAddCategoryDialogOpen(true)}
                          >
                            <AddIcon />
                          </Button>
                        </Stack>
                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                          <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Group</Typography>
                          <SelectTag
                            disabled={!['new', 'edit'].includes(currentAction)}
                            formControlSX={{
                              flex: 0.8,
                              border: currentAction ? '0.5px solid red' : ''
                            }}
                            name="group"
                            placeholder="Group"
                            menus={group.map((data) => ({
                              ...data,
                              name: data.group_name
                            }))}
                          />
                          <Button
                            sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                            variant="contained"
                            onClick={() => setAddGroupDialogueOpen(true)}
                          >
                            <AddIcon />
                          </Button>
                        </Stack>
                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                          <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Sub Group</Typography>
                          <SelectTag
                            formControlSX={{
                              flex: 0.8,
                              border: currentAction ? '0.5px solid red' : ''
                            }}
                            name="sub_group"
                            placeholder="Sub Group"
                            disabled={!['new', 'edit'].includes(currentAction)}
                            menus={subGroup.map((data) => ({
                              ...data,
                              name: data.sub_group
                            }))}
                          />
                          <Button
                            sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                            variant="contained"
                            onClick={() => setAddSubGroupDialogue(true)}
                          >
                            <AddIcon />
                          </Button>
                        </Stack>
                      </Stack>
                      <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                          <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Marke. By</Typography>
                          <SelectTag
                            disabled={!['new', 'edit'].includes(currentAction)}
                            formControlSX={{
                              flex: 0.8,
                              border: currentAction ? '0.5px solid red' : ''
                            }}
                            name="marke_by"
                            placeholder="Marketed By"
                            menus={marketed.map((data) => ({
                              ...data,
                              name: data.company_name
                            }))}
                          />
                          <Button
                            sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                            variant="contained"
                            onClick={() => setAddMarketedByDialogue(true)}
                          >
                            <AddIcon />
                          </Button>
                        </Stack>
                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                          <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Pur.Uom</Typography>
                          <SelectTag
                            disabled={!['new', 'edit'].includes(currentAction)}
                            formControlSX={{
                              flex: 0.8,
                              border: currentAction ? '0.5px solid red' : ''
                            }}
                            name="purchasing_unit"
                            placeholder="Purchasing Unit"
                            menus={purcahseUom.map((data) => ({
                              ...data,
                              name: data.unit_name
                            }))}
                          />
                          <Button
                            sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                            variant="contained"
                            onClick={() => setPurUomDialogue(true)}
                          >
                            <AddIcon />
                          </Button>
                        </Stack>
                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                          <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Sale UOM</Typography>
                          <SelectTag
                            disabled={!['new', 'edit'].includes(currentAction)}
                            formControlSX={{
                              flex: 0.8,
                              border: currentAction ? '0.5px solid red' : ''
                            }}
                            name="sale_uom"
                            placeholder="Sale UOM"
                            menus={purcahseUom.map((data) => ({
                              ...data,
                              name: data.unit_name
                            }))}
                          />
                          <Button
                            sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                            variant="contained"
                            onClick={() => setPurUomDialogue(true)}
                          >
                            <AddIcon />
                          </Button>
                        </Stack>
                      </Stack>

                      <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                          <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Packing</Typography>
                          <TextField
                            disabled={!['new', 'edit'].includes(currentAction)}
                            sx={{
                              flex: 0.8,
                              border: currentAction ? '0.5px solid red' : ''
                            }}
                            name="packing"
                            placeholder="Packing"
                            inputRef={fieldTwoRef}
                            onKeyDown={(e) => handleKeyPress(e, fieldThreeRef)}
                          />
                        </Stack>
                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                          <Typography sx={{ flex: 0.42, fontWeight: 700, fontSize: '1.4rem' }}>Box Qty.</Typography>
                          <TextField
                            disabled={!['new', 'edit'].includes(currentAction)}
                            sx={{ flex: 0.4 }}
                            name="box_qty"
                            placeholder=""
                          />
                          <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Conversion</Typography>
                          <TextField
                            disabled={!['new', 'edit'].includes(currentAction)}
                            sx={{
                              flex: 0.4,
                              border: currentAction ? '0.5px solid red' : ''
                            }}
                            name="conversion"
                            placeholder=""
                            inputRef={fieldThreeRef}
                            onKeyDown={(e) => handleKeyPress(e, fieldOneRef)}
                          />
                        </Stack>
                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                          <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Product Type</Typography>
                          <SelectTag
                            disabled={!['new', 'edit'].includes(currentAction)}
                            formControlSX={{
                              flex: 0.8,
                              border: currentAction ? '0.5px solid red' : ''
                            }}
                            name="product_type"
                            placeholder="Product Type"
                            menus={PHARMACY_PRODUCT_TYPE}
                          />
                        </Stack>
                      </Stack>

                      <Grid item xs={12}>
                        <Typography fontWeight="bold" sx={{ fontSize: '14px', boxShadow: '0px 2px 2px #0099ff' }}>
                          Taxation
                        </Typography>
                        <Divider />
                      </Grid>
                      <Stack sx={{ mb: 0.3, marginTop: '1%' }} direction="row" spacing={2}>
                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                          <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Tax Category</Typography>
                          <SelectTag
                            formControlSX={{
                              flex: 0.8,
                              border: currentAction ? '0.5px solid red' : ''
                            }}
                            name="tax_category"
                            placeholder="Tax Category"
                            disabled={!['new', 'edit'].includes(currentAction)}
                            menus={taxCategory.map((data) => ({
                              ...data,
                              name: data.tax_category_name
                            }))}
                          />
                          <Button
                            sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                            variant="contained"
                            onClick={() => setTaxCategoryDialogue(true)}
                          >
                            <AddIcon />
                          </Button>
                        </Stack>

                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                          <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>
                            Tax Percentage
                          </Typography>
                          <TextField
                            disabled={!['new', 'edit'].includes(currentAction)}
                            sx={{
                              flex: 0.8,
                              border: currentAction ? '0.5px solid red' : ''
                            }}
                            name="tax_percentage"
                            placeholder="Tax Percentage"
                          />
                        </Stack>

                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                          <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>HSN Code</Typography>
                          <TextField
                            disabled={!['new', 'edit'].includes(currentAction)}
                            sx={{
                              flex: 0.8,
                              border: currentAction ? '0.5px solid red' : ''
                            }}
                            name="hsn_code"
                            placeholder="HSN Code"
                          />
                        </Stack>
                      </Stack>

                      <Stack sx={{ mb: 0.3, marginTop: '1%' }} direction="row" spacing={2}>
                        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                          <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>Minimum Qty</Typography>
                          <TextField
                            sx={{
                              flex: 0.8,
                              border: currentAction ? '0.5px solid red' : ''
                            }}
                            name="minimum_qty"
                            placeholder="Minimum Qty"
                            disabled={!['new', 'edit'].includes(currentAction)}
                          />
                        </Stack>
                      </Stack>
                    </>
                  )}
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Product Master Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Product"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={originalData || []}
          loading={opdBillingDataObj.loading}
          onRowClick={(row) => {
            const { manuf, category, group, purchasing_unit, ...otherDetails } = row;
            setSelectedRecord({
              ...otherDetails,
              manuf: manuf?._id,
              category: category?._id,
              group: group?._id,
              purchasing_unit: purchasing_unit?._id
            });
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        open={taxCategoryDialogue}
        onClose={() => setTaxCategoryDialogue(false)}
        PaperProps={{ sx: { p: 2, width: '80%', height: '90vh' } }}
        maxWidth="xl"
        scroll="body"
      >
        <TaxCategoryMaster
          onClose={() => setTaxCategoryDialogue(false)}
          getTaxCategoryDropdown={getTaxCategoryDropdown}
          setTaxCategoryDialogue={setTaxCategoryDialogue}
        />
      </Dialog>

      <Dialog
        open={purUomDialogue}
        onClose={() => setPurUomDialogue(false)}
        PaperProps={{ sx: { p: 2, width: '80%', height: '90vh' } }}
        maxWidth="xl"
        scroll="body"
      >
        <PurchaseUom
          onClose={() => setPurUomDialogue(false)}
          getPurchaseUom={getPurchaseUom}
          setPurUomDialogue={setPurUomDialogue}
        />
      </Dialog>
      <Dialog
        open={addRouteDetailsDialogue}
        onClose={() => setAddRouteDetailsDialogue(false)}
        PaperProps={{ sx: { p: 2, width: '80%', height: '90vh' } }}
        maxWidth="xl"
        scroll="body"
      >
        <RouteDetails
          onClose={() => setAddRouteDetailsDialogue(false)}
          getRoute={getRoute}
          setAddRouteDetailsDialogue={setAddRouteDetailsDialogue}
        />
      </Dialog>
      <Dialog
        open={addProductStorageDialogue}
        onClose={() => setAddProductStorageDialogue(false)}
        PaperProps={{ sx: { p: 2, width: '80%', height: '90vh' } }}
        maxWidth="xl"
        scroll="body"
      >
        <ProductStorage
          onClose={() => setAddProductStorageDialogue(false)}
          getStorageDropdown={getStorageDropdown}
          setAddProductStorageDialogue={setAddProductStorageDialogue}
        />
      </Dialog>
      <Dialog
        open={addMarketedByDialogue}
        onClose={() => setAddMarketedByDialogue(false)}
        PaperProps={{ sx: { p: 2, width: '80%', height: '90vh' } }}
        maxWidth="xl"
        scroll="body"
      >
        <MarketedBy
          onClose={() => setAddMarketedByDialogue(false)}
          getMarketedDropdown={getMarketedDropdown}
          setAddMarketedByDialogue={setAddMarketedByDialogue}
        />
      </Dialog>
      <Dialog
        open={addSubGroupDialogue}
        onClose={() => setAddSubGroupDialogue(false)}
        PaperProps={{ sx: { p: 2, width: '80%', height: '90vh' } }}
        maxWidth="xl"
        scroll="body"
      >
        <SubGroup
          onClose={() => setAddSubGroupDialogue(false)}
          getSubGroupDropdown={getSubGroupDropdown}
          setAddSubGroupDialogue={setAddSubGroupDialogue}
        />
      </Dialog>
      <Dialog
        open={addGroupDialogueOpen}
        onClose={() => setAddGroupDialogueOpen(false)}
        PaperProps={{ sx: { p: 2, width: '80%', height: '90vh' } }}
        maxWidth="xl"
        scroll="body"
      >
        <Group
          onClose={() => setAddGroupDialogueOpen(false)}
          getGroupDropdown={getGroupDropdown}
          setAddGroupDialogueOpen={setAddGroupDialogueOpen}
        />
      </Dialog>
      <Dialog
        open={addCategoryDialogOpen}
        onClose={() => setAddCategoryDialogOpen(false)}
        PaperProps={{ sx: { p: 2, width: '80%', height: '90vh' } }}
        maxWidth="xl"
        scroll="body"
      >
        <ProductCategory
          onClose={() => setAddCategoryDialogOpen(false)}
          getCategoryDropdown={getCategoryDropdown}
          setAddCategoryDialogOpen={setAddCategoryDialogOpen}
        />
      </Dialog>
      <Dialog
        open={addManufacturerDialogOpen}
        onClose={() => setAddManufacturerDialogOpen(false)}
        PaperProps={{ sx: { width: '80%', height: '90vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <ManufacturerDetails
          onClose={() => setAddManufacturerDialogOpen(false)}
          getManufacturerDropdown={getManufacturerDropdown}
          setAddManufacturerDialogOpen={setAddManufacturerDialogOpen}
        />
      </Dialog>
    </>
  );
};
